export enum TcPermissionAction {
  Impersonate = 'impersonate',
}
